// Needs to have the same name as the Feature enum in CLB!

export enum FeatureSwitch {
  FEATURE_FOR_UNIT_TESTS = 'FEATURE_FOR_UNIT_TESTS',
  PPA_13204_RENT_APARTMENT_HOUSE_CL_DEPOSIT_GUARANTEE = 'PPA_13204_RENT_APARTMENT_HOUSE_CL_DEPOSIT_GUARANTEE',
}

export const FeatureSwitchesDefaultValues: FeatureSwitchMap = {
  [FeatureSwitch.FEATURE_FOR_UNIT_TESTS]: true,
  [FeatureSwitch.PPA_13204_RENT_APARTMENT_HOUSE_CL_DEPOSIT_GUARANTEE]: false,
}

export const ALL_FEATURES_ENABLED: FeatureSwitchMap = {
  [FeatureSwitch.FEATURE_FOR_UNIT_TESTS]: true,
  [FeatureSwitch.PPA_13204_RENT_APARTMENT_HOUSE_CL_DEPOSIT_GUARANTEE]: true,
}

export type FeatureSwitchMap = Partial<Record<FeatureSwitch, boolean>>
